"use client";

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  SearchIcon,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@workspace/frontend-ui";

type Props = {
  query: string;
  sort: ProvidersSortOption;
  labels: ProvidersGridLabels;
  onQueryChange: (query: string) => void;
  onSortChange: (sort: ProvidersSortOption) => void;
};

const ProvidersToolbar: FC<Props> = ({
  query,
  sort,
  labels,
  onQueryChange,
  onSortChange,
}) => {
  const handleQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onQueryChange(event.target.value);
  };

  const handleSortChange = (value: string) => {
    onSortChange(value as ProvidersSortOption);
  };

  return (
    <div className="flex gap-2" data-slot="providers-toolbar">
      <InputGroup className="h-12 sm:h-10 flex-1 rounded-md border-0 bg-secondary">
        <InputGroupAddon align="inline-start">
          <SearchIcon />
        </InputGroupAddon>
        <InputGroupInput
          type="search"
          value={query}
          onChange={handleQueryChange}
          placeholder={labels.searchPlaceholder}
          aria-label={labels.searchPlaceholder}
          className="h-full text-sm placeholder:text-muted-foreground"
        />
      </InputGroup>
      <Select value={sort} onValueChange={handleSortChange}>
        <SelectTrigger
          aria-label={labels.sortBy}
          className="w-36 shrink-0 data-[size=lg]:h-12 sm:data-[size=lg]:h-10 sm:w-48 border-0 bg-secondary"
          size="lg"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent position="popper" sideOffset={4}>
          {labels.sortOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ProvidersToolbar;
